import { Checkbox, Modal } from "antd";

const WhatsAppDialog = ({
  whatsAppOpen,
  handleWhatsAppCancel,
  whatsAppCheck,
  setWhatsAppCheck,
}) => {
  return (
    <Modal
      title={
        <strong
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#0cf38fff",
            borderRadius: "8px",
            padding: "4px 8px",
          }}
        >
          WhatsApp
        </strong>
      }
      open={whatsAppOpen}
      onOk={handleWhatsAppCancel}
      closable={false}
      okText="OK"
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #0a1a53", // ✅ Border here
          borderRadius: "8px",
          padding: "8px",
          color: "white",
          background: "#0a1a53",
        }}
        onClick={() => {
          if (whatsAppCheck === true) {
            setWhatsAppCheck(false);
          } else {
            setWhatsAppCheck(true);
          }
        }}
      >
        <Checkbox
          checked={whatsAppCheck}
          onChange={(e) => setWhatsAppCheck(e.target.checked)}
        />
        <span style={{ marginLeft: 8 }}>
          Are you sure you want to send WhatsApp?
        </span>
      </div>
    </Modal>
  );
};

export default WhatsAppDialog;
